import { useSyncExternalStore } from 'react';
import { ACCENTS, type AccentsType } from '@featit/shared/brand/colour-accents';

/**
 * F-0579: the look the root draws now (`data-accents`, set before the first frame by `index.html`
 * and kept by `AppearanceStore`), for a component whose markup, not only its CSS, differs by look.
 */
function read(): AccentsType {
  return typeof document !== 'undefined' &&
    document.documentElement.dataset.accents === ACCENTS.COLOUR
    ? ACCENTS.COLOUR
    : ACCENTS.QUIET;
}

function subscribe(listener: () => void): () => void {
  if (typeof MutationObserver === 'undefined') return () => undefined;
  const observer = new MutationObserver(listener);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-accents'],
  });
  return () => observer.disconnect();
}

export function useAccents(): AccentsType {
  return useSyncExternalStore(subscribe, read, () => ACCENTS.QUIET);
}
